import addSidebarListener from './events/sidebar-listener'
import configuration from '@/taskpane/common/configuration'
import office from '@/taskpane/officejs/office-wrapper'
import state from '@/taskpane/state/sidebar-state'
import officeApiSupportedRequirementSets from '@/taskpane/officejs/async/infrastructure/office-api-get-supported-requirement-sets'
import addItemChangeListener from './events/item-change-listener'
import graph from './graph/graph-wrapper'

Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
    initializeSidebarState()

    addSidebarListener()
    addItemChangeListener()
    setSidebarUrl()
  }
})

function initializeSidebarState() {
  configuration.SUPPORTED_REQUIREMENT_SETS = officeApiSupportedRequirementSets()

  state.userEmail = office.profile.username()
  state.currentItem.apiInfo.isEwsApiAvailable = office.ews.isAvailable()
  state.currentItem.apiInfo.isGraphApiAvailable = graph.isAvailable()
}

async function setSidebarUrl() {
  const baseUrl = getSidebarBaseUrl()

  try {
    const people = await office.people.emailAddresses()
    const emails = people.map((email) => encodeURIComponent(email)).join(',')
    let fullUrl = baseUrl + '&emails=' + emails

    const threadId = office.mail.conversationId()
    if (threadId) {
      fullUrl += '&threadId=' + encodeURIComponent(threadId)
    }

    const trackingId = await office.customProps.getTrackingId()
    if (trackingId) {
      fullUrl += '&uuid=' + encodeURIComponent(trackingId)
    }

    setIFrameSource(fullUrl)
  } catch {
    setIFrameSource(baseUrl)
  }
}

function getSidebarBaseUrl(): string {
  const urlParams = new URLSearchParams(window.location.search)
  const manifestVersion = urlParams.get('manifestVersion') || ''
  const clientEmail = office.profile.username()
  const outlookVersion = office.platform.outlookClientVersion()
  const requirementSetVersion = office.platform.highestSupportedRequirementSet()

  // prettier-ignore
  let url = configuration.CIRRUS_PORTAL +
    '/#/sidebar/people?socket=none&client=owa&groupId=' + configuration.LEGACY_SOCKET_GROUP_ID +
    '&manifestVersion=' + manifestVersion +
    '&outlookVersion=' + outlookVersion +
    '&requirementSetVersion=' + requirementSetVersion

  if (office.platform.isMobile()) {
    url += '&clientEmail=' + encodeURIComponent(clientEmail)
  }

  return url
}

function setIFrameSource(src: string) {
  document.getElementById('sidebarFrame').setAttribute('src', src)
}
